<template>
  <v-tabs class="mt-0" v-model="currentSystemTab">
    <v-dialog
      v-model="admin.showEditSystemDialog"
      max-width="650"
      persistent
      @keydown.esc="closeSystemDialog"
    >
      <system-edit class="mt-6" :min-card-height="400"></system-edit>
    </v-dialog>
    <v-dialog
      v-model="admin.showEditSubsystemDialog"
      max-width="650"
      persistent
      @keydown.esc="closeSubsystemDialog"
    >
      <sub-system-edit></sub-system-edit>
    </v-dialog>
    <v-dialog
      v-model="admin.showEditComponentDialog"
      max-width="650"
      persistent
      @keydown.esc="closeComponentDialog"
    >
      <component-edit></component-edit>
    </v-dialog>
    <v-tab>Systems</v-tab>
    <v-tab v-show="admin.selectedSystem != null"
      >{{ subsystemTabName }} Subsystems</v-tab
    >
    <v-tab v-show="admin.selectedComponent != null"
      >Component {{ componentTabName }}</v-tab
    >
    <!-- System Tab Item -->
    <v-tab-item class="px-8">
      <v-row>
        <v-col>
          <system-list></system-list>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <subsystem-list :min-card-height="880"></subsystem-list>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Subsystem Tab Item-->
    <v-tab-item v-show="admin.selectedSystem != null" class="px-8">
      <v-row>
        <v-col>
          <subsystem-list :min-card-height="400"></subsystem-list>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <component-list :min-card-height="880"></component-list>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Component Tab Item -->
    <v-tab-item v-show="admin.selectedSubsystem != null" class="px-8">
      <v-row>
        <v-col>
          <component-list :min-card-height="400"></component-list>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <component-details></component-details>
        </v-col>
      </v-row>
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import { mapState } from 'vuex';
  import ComponentList from '../components/component/ComponentList.vue';
  import SubSystemEdit from '../components/subsystem/SubsystemEdit.vue';
  import SystemEdit from '../components/system/SystemEdit.vue';
  import SystemList from '../components/system/SystemList.vue';
  import SubsystemList from '../components/subsystem/SubsystemList.vue';
  import ComponentEdit from '../components/component/ComponentEdit.vue';
  import ComponentDetails from '../components/component/ComponentDetails.vue';

  export default {
    components: {
      SystemList,
      SystemEdit,
      SubsystemList,
      SubSystemEdit,
      ComponentList,
      ComponentEdit,
      ComponentDetails
    },
    data() {
      return {
        selectedSystem: null
      };
    },
    methods: {
      closeSystemDialog() {
        this.$store.commit('admin/setShowEditSystemDialog', false);
      },
      closeSubsystemDialog() {
        this.$store.commit('admin/setShowEditSubsystemDialog', false);
      },
      closeComponentDialog() {
        this.$store.commit('admin/setShowEditComponentDialog', false);
      }
    },
    computed: {
      ...mapState(['app', 'admin']),
      currentSystemTab: {
        get() {
          return this.admin.currentSystemTab;
        },
        set(value) {
          this.$store.commit('admin/setCurrentSystemTab', value);
        }
      },
      subsystemTabName: {
        get() {
          return ` [${this.admin.selectedSystem?.name}]`;
        }
      },
      componentTabName: {
        get() {
          return ` [${this.admin.selectedComponent?.name}]`;
        }
      }
    }
  };
</script>
